import { IGlobalProduct, ITcc } from "../../../../types/data.interface";
import { ExpandableSection } from "../expandable-section";
import { useCreateMpnStore } from "../../context/create/CreateMpnContext";
import { Tooltip } from "react-tooltip";
import { Predicates } from "../../../../libraries/predicates/predicates";

type HierarchyInfoSectionProps = {
  tcc: ITcc | null;
  gp: IGlobalProduct | null;
};

const HierarchyInfoSection = () => {
  const { state, dispatch } = useCreateMpnStore();

  return (
    <>
      {/*{gp && (*/}
      <ExpandableSection sectionId={"hierarchy"} title="MPN Hierarchy">
        <div className="row form-row gap-2">
          <div className="col-md form-group  align-items-center">
            <label className="form-label mb-0 mr-2 text-nowrap">Category</label>
            <textarea
              value={
                state.category
                  ? `${state?.category?.code} - ${state?.category?.name}`
                  : ""
              }
              disabled={true}
              rows={1}
              className="form-control d-inline no-resize horizontal-scroll"
            />
          </div>

          <div className="col-md form-group  align-items-center">
            <label className="form-label mb-0 mr-2 text-nowrap">
              Sub-Category
            </label>
            <textarea
              value={
                state.sub_category
                  ? `${state?.sub_category?.code} - ${state?.sub_category?.name}`
                  : ""
              }
              // value={`${gp.sub_category.code} - ${gp.sub_category.name}`}
              disabled={true}
              rows={1}
              className="form-control d-inline no-resize horizontal-scroll"
            />
          </div>

          <div className="col-md form-group  align-items-center">
            <label className="form-label mb-0 mr-2 text-nowrap">
              Product Line
            </label>
            <textarea
              value={
                state.product_line
                  ? `${state?.product_line?.code} - ${state?.product_line?.name}`
                  : ""
              }
              disabled={true}
              rows={1}
              className="form-control d-inline no-resize horizontal-scroll"
            />
          </div>
        </div>

        <div className="row form-row gap-2">
          <div className="col-md form-group align-items-center mb-0">
            <label
              className="form-label mb-0 mr-2 text-nowrap"
              data-tooltip-id="GP-tooltip"
              data-tooltip-html={"Global Product"}
              aria-label="Global Product"
            >
              Global Product
            </label>
            <Tooltip
              id="GP-tooltip"
              className="tooltip-text-box"
              place="left-end"
              noArrow={true}
            />
            <textarea
              value={
                Predicates.isNotNullAndNotUndefinedAndNotEmpty(`${state.global_product?.gpc_gpcode}`) && `${state.global_product?.gpc_gpcode}`.length > 4
                  ? `${state?.global_product?.gpc_gpcode} - ${state?.global_product?.name}`
                  : Predicates.isNotNullAndNotUndefinedAndNotEmpty(`${state.global_product?.gpc_lgycod}`)
                ? `${state?.global_product?.gpc_lgycod} - ${state?.global_product?.name}`: ""
              }
              disabled={true}
              rows={1}
              className="form-control d-inline no-resize horizontal-scroll"
            />
          </div>

          <div className="col-md form-group align-items-center mb-0">
            <label
              className="form-label mb-0 mr-2 text-nowrap"
              data-tooltip-id="item-number-tooltip"
              data-tooltip-html={"Item Number"}
              aria-label="Item Number"
            >
              Item Number
            </label>
            <Tooltip
              id="item-number-tooltip"
              className="tooltip-text-box"
              place="left-end"
              noArrow={true}
            />

            <textarea
              value={
                Predicates.isNotNullAndNotUndefinedAndNotEmpty(
                  state.itemNumber?.itn_itemno,
                )
                  ? `${state.itemNumber?.itn_itemno} - ${state.itemNumber?.itn_itemnm}`
                  : Predicates.isNotNullAndNotUndefinedAndNotEmpty(
                        state.itemNumber?.pch_lgycod,
                      )
                    ? `${state.itemNumber?.pch_lgycod} - ${state.itemNumber?.name}`
                    : ""
              }
              disabled={true}
              rows={1}
              className="form-control d-inline no-resize horizontal-scroll"
            />
          </div>

        <div className="col-md form-group align-items-center mb-0">
            <label className="form-label mb-0 mr-2 text-nowrap">
              Collection
            </label>

            <textarea
              value={
                state.itemNumber?.artwork_collection
                  ? `${state.itemNumber?.artwork_collection.code} - ${state.itemNumber?.artwork_collection.name}`
                  : ""
              }
              disabled
              rows={1}
              className="form-control d-inline no-resize horizontal-scroll"
            />
          </div>

        </div>
      </ExpandableSection>
    </>
  );
};

export default HierarchyInfoSection;
